export default "__VITE_ASSET__e95757c5__"